/**
 * Feature flags and their local defaults. The keys follow GrowthBook's naming (snake_case)
 * so the same keys work once a GrowthBook client is wired in (architecture.md §3:
 * "progress rail on/off, hero copy, chip default").
 */
export const FLAG_DEFAULTS = {
  /** Three-stage progress rail in the chrome (design rule 9). */
  progress_rail: true,
  /** S3 default chip when S0 gave no hint: 'delayed' | 'cancelled' | 'all'. */
  s3_default_chip: 'delayed' as 'delayed' | 'cancelled' | 'all',
  /** Dev drawer (⚙). Only ever on in dev builds; see DevDrawer. */
  dev_drawer: true,
};

export type Flags = typeof FLAG_DEFAULTS;
export type FlagKey = keyof Flags;
